"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _GlobalFunctions = _interopRequireDefault(require("GlobalFunctions"));
var _Application = _interopRequireDefault(require("Application"));
var _styles = require("@material-ui/core/styles");
var _locale = require("@material-ui/core/locale");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const {
  app
} = window;

// https://material-ui.com/customization/default-theme/
const theme = (0, _styles.createTheme)({
  palette: {
    primary: {
      main: '#22a2b5',
      light: '#28b9ce',
      dark: '#003f66'
    },
    secondary: {
      main: '#ef7c01'
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 1024,
      lg: 1326,
      xl: 1400
    }
  }
}, _locale.frFR);
document.addEventListener('DOMContentLoaded', function () {
  let app_container = document.getElementById('app');
  if (!app_container) return console.error('missing #app <div> on the page');
  app_container.addEventListener('click', function () {
    app.emit({
      event: 'documentClick'
    });
  });
  _reactDom.default.render(/*#__PURE__*/_react.default.createElement(_styles.StylesProvider, {
    injectFirst: true
  }, /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_Application.default, null))), app_container);
});
